// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLeaseExtensionFromOuidWebApiResponseDto } from '../..';

interface GetLeaseExtensionFromOuidParams {
  ouid: string;
}

export const LeaseRenewalOuidWebApiHandler_getLeaseExtensionFromOuid_Path =
  '/api/web/v1/ouid/getLeaseExtensionFromOuid';

/**
 * get lease extension from OUID
 */
export const LeaseRenewalOuidWebApiHandler_getLeaseExtensionFromOuid = (
  getParams: GetLeaseExtensionFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseExtensionFromOuidParams, never, GetLeaseExtensionFromOuidWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseRenewalOuidWebApiHandler_getLeaseExtensionFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
